"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientFieldCardDescription = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var Info_1 = require("../../../gen-src/icons/Info");
var VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
function VizClientFieldCardDescription(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var markupEditingEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).markupEditingEnabled;
    var field = props.field;
    if (field.description) {
        return React.createElement(DirectDescription, { description: field.description, markupEditingEnabled: markupEditingEnabled });
    }
    var column = maybeGetColumnFromField(field);
    if (column) {
        if (column.description) {
            return React.createElement(ColumnDescription, { column: column, markupEditingEnabled: markupEditingEnabled });
        }
        if (((_d = (_c = (_b = (_a = column.referencedByFlowColumnOutputField) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.parentFields) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.__typename) === 'FlowColumnInputField') {
            var upstreamColumn = (_h = (_g = (_f = (_e = column.referencedByFlowColumnOutputField) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.parentFields) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.column;
            if (upstreamColumn === null || upstreamColumn === void 0 ? void 0 : upstreamColumn.description) {
                return React.createElement(ColumnDescription, { column: upstreamColumn, markupEditingEnabled: markupEditingEnabled });
            }
        }
    }
    if (field.__typename === 'DatasourceField') {
        var remoteField = field.remoteField;
        if (remoteField) {
            if (remoteField.description) {
                return React.createElement(RemoteFieldDescription, { remoteField: remoteField, markupEditingEnabled: markupEditingEnabled });
            }
            var remoteColumn = maybeGetColumnFromField(remoteField);
            if (remoteColumn && remoteColumn.description) {
                return (React.createElement(RemoteColumnDescription, { remoteColumn: remoteColumn, remoteField: remoteField, markupEditingEnabled: markupEditingEnabled }));
            }
            if (((_m = (_l = (_k = (_j = remoteField.referencedByFlowFieldOutputField) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.parentFields) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.__typename) === 'FlowColumnInputField') {
                var remoteUpstreamColumn = (_r = (_q = (_p = (_o = remoteField.referencedByFlowFieldOutputField) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.parentFields) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.column;
                if (remoteUpstreamColumn === null || remoteUpstreamColumn === void 0 ? void 0 : remoteUpstreamColumn.description) {
                    return (React.createElement(RemoteColumnDescription, { remoteColumn: remoteUpstreamColumn, remoteField: remoteField, markupEditingEnabled: markupEditingEnabled }));
                }
            }
        }
    }
    return React.createElement(NoDescription, null);
}
exports.VizClientFieldCardDescription = VizClientFieldCardDescription;
function FieldCardDetailMarkup(props) {
    var linksDisabled = props.linksDisabled, restProps = __rest(props, ["linksDisabled"]);
    return (React.createElement(VizClientFieldCardStyles_1.FieldCardDetailMarkupWrapper, null,
        React.createElement(widgets_1.TextFormatterDisplayWidget, __assign({}, restProps))));
}
function DirectDescription(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, null),
        props.markupEditingEnabled ?
            React.createElement(FieldCardDetailMarkup, { markup: props.description }) :
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, props.description)));
}
function ColumnDescription(props) {
    var description = props.column.description;
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceColumn: props.column }),
        props.markupEditingEnabled ?
            React.createElement(FieldCardDetailMarkup, { markup: description !== null && description !== void 0 ? description : '' }) :
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, description)));
}
function RemoteFieldDescription(props) {
    var description = props.remoteField.description;
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceField: props.remoteField }),
        props.markupEditingEnabled ?
            React.createElement(FieldCardDetailMarkup, { markup: description !== null && description !== void 0 ? description : '' }) :
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, description)));
}
function RemoteColumnDescription(props) {
    var description = props.remoteColumn.description;
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, { sourceColumn: props.remoteColumn, sourceField: props.remoteField }),
        props.markupEditingEnabled ?
            React.createElement(FieldCardDetailMarkup, { markup: description !== null && description !== void 0 ? description : '' }) :
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, description)));
}
function NoDescription() {
    return (React.createElement(React.Fragment, null,
        React.createElement(DescriptionTitle, null),
        React.createElement(VizClientFieldCardStyles_1.NoDescriptionPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable())));
}
function DescriptionTitle(props) {
    return (React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null,
            Localize_1.Messages.Description(),
            React.createElement(DescriptionInfo, __assign({}, props)))));
}
function DescriptionInfo(props) {
    var column = props.sourceColumn;
    var field = props.sourceField;
    if (column || field) {
        var getDescriptionTooltipContent = function () {
            if (column && field) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromColumnThoughField({
                    column: '[COLUMN]',
                    table: '[TABLE]',
                    field: '[FIELD]',
                    datasource: '[DATASOURCE]',
                }), {
                    COLUMN: React.createElement(ColumnLink, { key: 'column-link', column: column }),
                    TABLE: React.createElement(TableLink, { key: 'table-link', table: column.table }),
                    FIELD: React.createElement(FieldLink, { key: 'field-link', remoteField: field }),
                    DATASOURCE: React.createElement(DatasourceLink, { key: 'datasource-link', remoteField: field }),
                })));
            }
            else if (field) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromField({
                    field: '[FIELD]',
                    datasource: '[DATASOURCE]',
                }), {
                    FIELD: React.createElement(FieldLink, { key: 'field-link', remoteField: field }),
                    DATASOURCE: React.createElement(DatasourceLink, { key: 'field-link', remoteField: field }),
                })));
            }
            else if (column) {
                return Promise.resolve(React.createElement(VizClientFieldCardStyles_1.DescriptionTooltipText, null, data_catalog_shared_1.interpolateString(Localize_1.Messages.DescriptionInfoInheritedFromColumn({
                    column: '[COLUMN]',
                    table: '[TABLE]',
                }), {
                    COLUMN: React.createElement(ColumnLink, { key: 'column-link', column: column }),
                    TABLE: React.createElement(TableLink, { key: 'table-link', table: column.table }),
                })));
            }
            else {
                return Promise.resolve(null);
            }
        };
        return (React.createElement("span", { className: VizClientFieldCardStyles_1.fieldCardDetailTitleIconClass },
            React.createElement(widgets_1.ChromeTooltipWidget, { getContent: getDescriptionTooltipContent, width: 300 },
                React.createElement(Info_1.SvgInfo, null))));
    }
    else {
        return null;
    }
}
function ColumnLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-column-link', href: maybeColumnUrl(props.column, urls), target: '_blank' }, props.column.name);
    }));
}
function maybeColumnUrl(column, urls) {
    return column.table
        ? urls.catalogTableColumnUrl(column.table.id, column.id)
        : '';
}
function TableLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-table-link', href: maybeTableUrl(props.table, urls), target: '_blank' }, props.table ? props.table.name : '');
    }));
}
function maybeTableUrl(table, urls) {
    return table
        ? urls.catalogTableUrl(table.id)
        : '';
}
function FieldLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-field-link', href: maybeFieldUrl(props.remoteField, urls), target: '_blank' }, props.remoteField.name);
    }));
}
function maybeFieldUrl(remoteField, urls) {
    return remoteField.datasource && remoteField.datasource.__typename === 'PublishedDatasource'
        ? urls.datasourceLineageFieldUrl(remoteField.datasource.vizportalUrlId, remoteField.id)
        : '';
}
function maybeGetColumnFromField(field) {
    if (field.__typename === 'ColumnField') {
        var columnsConnection = field.columnsConnection;
        if (columnsConnection) {
            var columns = columnsConnection.nodes;
            if (columns && columns.length > 0) {
                var column = columns[0];
                if (column) {
                    return column;
                }
            }
        }
    }
    return null;
}
function DatasourceLink(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        var _a;
        return React.createElement(widgets_1.TextLinkWidget, { testId: 'description-tooltip-datasource-link', href: maybeDatasourceUrl(props.remoteField, urls), target: '_blank' }, ((_a = props.remoteField.datasource) === null || _a === void 0 ? void 0 : _a.name) || '');
    }));
}
function maybeDatasourceUrl(remoteField, urls) {
    return remoteField.datasource && remoteField.datasource.__typename === 'PublishedDatasource'
        ? urls.datasourceLineageUrl(remoteField.datasource.vizportalUrlId)
        : '';
}
//# sourceMappingURL=VizClientFieldCardDescription.js.map